import { http } from '@/core/helpers/http.helper';
import { LocationQuery } from 'vue-router';
import { ApiResource } from './../../../models/api-resource.interface';
import { InternalJobFunction } from './../../internal-job-functions/internal-job-function.interface';
export class InternalJobFunctionService {
   async getInternalJobFunctions(tenantId: number, query?: LocationQuery) {
      const response = await http.get<ApiResource<Array<InternalJobFunction>>>(`/tenants/${tenantId}/internal-job-functions`, {
         params: { ...query },
      });
      return response.data;
   }

   async getInternalJobFunction() {
      throw Error('Method not implemented');
   }

   async postInternalJobFunction(tenantId: number, internalJobFunction: InternalJobFunction) {
      const response = await http.post<InternalJobFunction>(`/tenants/${tenantId}/internal-job-functions`, internalJobFunction);
      return response.data;
   }

   async putInternalJobFunction(tenantId: number, internalJobFunctionId: number, internalJobFunction: InternalJobFunction) {
      const response = await http.post<InternalJobFunction>(
         `/tenants/${tenantId}/internal-job-functions/${internalJobFunctionId}`,
         internalJobFunction
      );
      return response.data;
   }

   async deleteInternalJobFunction(tenantId: number, internalJobFunctionId: number) {
      const response = await http.delete(`/tenants/${tenantId}/internal-job-functions/${internalJobFunctionId}`);
      return response.data;
   }
}
